import { Button } from 'common/Components/Button';
import { useRouter } from 'common/hooks/useRouter';
import { useTranslation } from 'react-i18next';

/** need 
1. temperoryToken from state in react-router
*/

export const Form = () => {
  const {
    navigate,
    history: {
      state: { temperoryToken },
    },
  } = useRouter();

  const handleClickChangePassword = () => {
    navigate.push(`/change-password/otp`, {
      state: { temperoryToken, force: true },
    });
  };


  const { t } = useTranslation();

  return (
    <div className=" md:mb-9">
      <Button
        className="w-full bg-L-secondary-50 dark:bg-D-secobg-L-secondary-50 rounded text-L-basic dark:text-D-basic p-2 md:mt-5 text-2xl !font-medium"
        onClick={handleClickChangePassword}
      >
        {t(`FormSide.Confirm.ChangePassword`)}
      </Button>
      <div className="flex justify-center gap-x-3 items-center mt-2">
        <Button
          className="w-full mt-2 contents text-xl"
          onClick={(e) => {
            e.preventDefault()
            navigate.pushLogin()
          }}
        >
          {t(`FormSide.BackText`)}
        </Button>
      </div>
    </div>
  );
};
